import { Col, Row } from '@/app/components/Flex/Flex'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import DoSvg from '@/app/icons/do.svg?react'
import DontSvg from '@/app/icons/dont.svg?react'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const PlusMinus: FunctionalComponent<{
  plusTitle: string
  minusTitle: string
  plus: string[]
  minus: string[]
}> = props => {
  return (
    <UI.Panel>
      <Row gap={20}>
        <Row gap={10}>
          <Text
            upper
            as='h2'
            fontSize={13}
            fontWeight={600}
          >
            {props.plusTitle}
          </Text>
          <Row gap={10}>
            {props.plus.map(item => (
              <Col key={item} gap={10} alignItems='flex-start'>
                <DoSvg width={20} height={20} class={styles.do} />
                <Text fontSize={16}>{item}</Text>
              </Col>
            ))}
          </Row>
        </Row>

        <Row gap={10}>
          <Text
            upper
            as='h2'
            fontSize={13}
            fontWeight={600}
          >
            {props.minusTitle}
          </Text>
          <Row gap={10}>
            {props.minus.map(item => (
              <Col key={item} gap={10} alignItems='flex-start'>
                <DontSvg width={20} height={20} class={styles.dont} />
                <Text fontSize={16}>{item}</Text>
              </Col>
            ))}
          </Row>
        </Row>
      </Row>
    </UI.Panel>
  )
}
